import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const NotificationItem = ({ t, notification, onClick, onMarkRead }) => (
    <div
        className={`notifications-panel-item ${!notification.read_at ? 'is-unread' : ''}`}
        onClick={() => onClick(notification)}
    >
        <div className="notifications-panel-item-content">
            <span className="notifications-panel-item-title">{notification.title}</span>
            {!!notification.body && (
                <span className="notifications-panel-item-body">{notification.body}</span>
            )}
            <span className="notifications-panel-item-time">
                {moment(notification.created_at).fromNow()}
            </span>
        </div>
        {!notification.read_at && (
            <button
                type="button"
                className="notifications-panel-item-check"
                aria-label={t('layout.notifications.mark_as_read')}
                title={t('layout.notifications.mark_as_read')}
                onClick={(e) => {
                    e.stopPropagation();
                    onMarkRead(notification);
                }}
            >
                <Check size={16} />
            </button>
        )}
    </div>
);

export default withTranslation()(NotificationItem);
